import { render, staticRenderFns } from "./EmSicDowntimeRecordSdrList.vue?vue&type=template&id=bda5f5fa&"
import script from "./EmSicDowntimeRecordSdrList.vue?vue&type=script&lang=js&"
export * from "./EmSicDowntimeRecordSdrList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports